import mapFunction from './mapResources';

export default mapFunction('professions', {
    isFetching: false,
    items: [] 
});
